export const getTimezoneInfo = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMin = -new Date().getTimezoneOffset();
    const sign = offsetMin >= 0 ? "+" : "-";
    const hh = String(Math.floor(Math.abs(offsetMin) / 60)).padStart(2, "0");
    const mm = String(Math.abs(offsetMin) % 60).padStart(2, "0");
    return { tz, offset: `UTC${sign}${hh}:${mm}` };
  } catch (_) {
    return { tz: "Local", offset: "UTC" };
  }
};

export const getTimezoneAbbreviation = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "short",
    }).formatToParts(new Date());
    const abbr = parts.find((p) => p.type === "timeZoneName")?.value || "";
    return abbr || "UTC";
  } catch (_) {
    return "UTC";
  }
};

export const formatLocalDateTime = (input) => {
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return "";
    // Example: Sep 22, 2025, 14:05 (no seconds)
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (_) {
    return "";
  }
};
